import {inject, Injectable} from "@angular/core";
import { BaseComponent } from '@wms/components';
import { forEach } from 'lodash-es';
import { toJson, fromJson } from '@wms/core';
import {ProjectService} from "@wms/services";


let prefix   = 'wms:state',
  $storage = window.sessionStorage,
  KEY: any, state: any;


@Injectable({
  providedIn: 'root'
})
export class StateManagerService extends BaseComponent {

  constructor() {
    super();
    KEY = '$' + prefix + '$' + this.projectService.getProjectId() + '$'
  }

  // removes params/details which are not to be stored
  filterParams() {
    forEach(state.openWS, function (ws) {
      // delete ws.details.cursorPosText;
      // delete ws._category;
    });
  }

  save() {
    this.filterParams();
    $storage.setItem(KEY, toJson(state));
  }

  retrieve() {

    if (!state) {
      state = fromJson($storage.getItem(KEY));
    }

    if (!state) {
      //initialize
      state = {
        openWS: [],
        deviceInfo: undefined
      };
    }

    return state;
  }

  setWSState(data: any) {
    state.openWS = data;
    this.save();
  }

  getWSState() {
    var _state = this.retrieve();
    return _state.openWS;
  }

  setDeviceInfo (data: any) {
    if (data.device) {
      state.deviceInfo = data;
    } else {
      delete state.deviceInfo;
    }
    this.save();
  }

  getDeviceInfo() {
    var _state = this.retrieve();
    return _state.deviceInfo;
  }

  cleanup() {
    $storage.removeItem(KEY);
  }

}
